//import hook react
import React, { useState } from 'react';

import axios from 'axios';

function UserForm(p) {

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    const changePasswordHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', p.user.email);
        formData.append('password', newPassword);
        formData.append('password_confirmation', confirmPassword);

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/changepassword', formData)
            .then((response) => {
                console.log('sukses ganti password');
            })
            .catch((error) => {
                console.log('gagal ganti password');
            })
    };

    const aktivasiHandler = async (e) => {
        e.preventDefault();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('emails[]', p.user.email);

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/broadcast', formData)
            .then((response) => {
                console.log('sukses ganti password');
            })
            .catch((error) => {
                console.log('gagal ganti password');
            })
    }

    if (p.state) {
        return (
            <div className="tab-content pt-3">
                <div className="tab-pane active">
                    <form className="form" onSubmit={changePasswordHandler}>
                        <div className="row">
                            <div className="col">
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Nama</label>
                                            <input className="form-control" type="text" name="name" value={p.user.name} readOnly></input>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Email</label>
                                            <input className="form-control" type="text" name="username" value={p.user.email} readOnly></input>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Kode Dosen / Mahasiswa</label>
                                            <input className="form-control" type="text" name="username" value={p.user.nomor_induk} readOnly></input>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Tipe User</label>
                                            <input className="form-control" type="text" name="username" value={p.user.user_type} readOnly></input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-6 mb-3">
                                <div className="mb-2"><b>Ganti Password</b></div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Password Baru</label>
                                            <input className="form-control" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}></input>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label>Konfirmasi <span className="d-none d-xl-inline">Password</span></label>
                                            <input className="form-control" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}></input>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col d-flex">
                                <button className="btn btn-primary" type="submit">Ganti Password</button>
                                {/* <button className="btn btn-secondary" type="button" onClick={aktivasiHandler}>Kirim Aktivasi Email</button> */}
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        );
    }
}

export default UserForm;